import { ScrollView, View } from 'react-native';
import { PrimaryButton } from '../buttons/primary-button/PrimaryButton';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { useStore } from 'src/contexts/StoreContext';
import { ACTIVE_TOOLS } from 'src/store/page-project/pageProject.constants';
import { observer } from 'mobx-react-lite';
import { style } from './BottomSheetFilters.style';
import { BottomBarEditCard } from '../bottom-bar-edit/BottomBarEditCard';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { useFocusableGroups } from 'src/hooks/useFocusableGroup';
import { filterTestID } from 'src/helpers/testIDs.helper';
import { TestIDs } from 'src/constants/testIDs.constants';

export const BottomSheetFilters = observer(() => {
  const {
    i18n,
    project: { setActiveTool, activeUserImageArea },
  } = useStore();

  useFocusableGroups([FocusGroups.BOTTOM_SHEET]);

  const FILTER_CARDS = activeUserImageArea?.userImage?.filtersMiniatures?.map(filter => {
    return {
      uri: filter.miniatureUrl,
      text: i18n.t(`filters:${filter.filter}`),
      onPress: () => {
        activeUserImageArea.userImage?.applyFilter(filter.filter);
        amplitude.trackEvent(AnalyticsEvents.modifyPhoto.filterClick, { filter_choice: filter.filter });
      },
      filterName: filter.filter,
    };
  });

  const onPress = () => {
    setActiveTool(ACTIVE_TOOLS.frame);
  };

  return (
    <View style={style.container}>
      <ScrollView
        style={{ flex: 1 }}
        horizontal
        contentContainerStyle={style.cardsWrapper}
        showsHorizontalScrollIndicator={false}
      >
        {FILTER_CARDS?.map((card, index) => {
          return (
            <BottomBarEditCard
              card={card}
              isSelected={activeUserImageArea?.userImage?.filter.toLocaleLowerCase() === card.filterName}
              key={card.text}
              focusId={filterTestID(card.filterName)}
              focusOrder={index}
            />
          );
        })}
      </ScrollView>
      <View style={style.ctaWrapper}>
        <PrimaryButton
          focusGroup={FocusGroups.BOTTOM_SHEET}
          focusOrder={FILTER_CARDS?.length ?? 0}
          focusId={filterTestID(TestIDs.CLOSE)}
          onPress={async () => onPress()}
          text={i18n.t('adjustments:close')}
        />
      </View>
    </View>
  );
});
